<template>
  <div class="main-chapter1">
    <div class="chapter-title">
      Список инженерно-технического персонала, занятого выполнением сварочных работ
    </div>
    <n-table :columns="columns" :data="data" :loading="$var('load')">
      <template #startedAt="{item}">
        {{ $app.date.format(item.startedAt) }}
      </template>
      <template #endedAt="{item}">
        {{ $app.date.format(item.endedAt) }}
      </template>
    </n-table>
  </div>
</template>

<script>
export default {
  name: 'MainChapter3',
  props: [ 'project', 'journal', ],
  data: () => ({
    columns: [
      { name: 'fullName', title: 'Фамилия, имя отчество', },
      { name: 'speciality', title: 'Специальность и образование', },
      { name: 'position', title: 'Занимаемая должность', },
      { name: 'startedAt', title: 'Дата начала работы на объекте', },
      { name: 'attestation', title: 'Отметка о прохождении аттестации и дата аттестации', },
      { name: 'endedAt', title: 'Дата окончания работы на объекте', },
    ],
    data: [],
  }),
  created() {
    // this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      // $api.journals.spec32.two.get(this.project.id, 'spec32').then((response) => {
      //   this.data = response.data.content
      // }).finally(() => {
      //   this.$var('load', false)
      // })
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
